import { action } from 'mobx';
import { request } from 'utils/api';
import BaseStore from './BaseStore';

export default class FormSubmissionStore extends BaseStore {
  @action
  save(fields, pathname, metadata = {}) {
    return request({
      method: 'POST',
      path: '/1/forms/submission/',
      body: {
        fields,
        pathname,
        ...metadata,
      },
    });
  }

  @action
  sendToMonday(fields, modular = false) {
    return request({
      method: 'POST',
      path: '/1/forms/monday/',
      body: {
        fields,
        modular,
      },
    });
  }

  @action
  getMondaySelectOptions(columnIds) {
    return request({
      method: 'POST',
      path: '/1/forms/monday/options',
      body: {
        columnIds,
      },
    });
  }

  @action
  notify(name, fields, to) {
    request({
      method: 'POST',
      path: '/1/forms/notify/',
      body: { name, fields, to },
    });
  }

  @action
  sendContactForm({ name, email, type, phone, message, emailTo }) {
    return request({
      method: 'POST',
      path: '/1/contact/sendForm',
      body: { name, email, type, phone, message, emailTo },
    });
  }
}
